import { graphql, useStaticQuery } from 'gatsby';

export function usePagePathsInfo() {
  const { pagesEn, pagesDe, pagesAe, pagesAz, pagesUk, pagesKz, pagesPl } = useStaticQuery(graphql`
    query {
      pagesEn {
        paths
      }
      pagesDe {
        paths
      }
      pagesAe {
        paths
      }
      pagesAz {
        paths
      }
      pagesUk {
        paths
      }
      pagesKz {
        paths
      }
      pagesPl {
        paths
      }
    }
  `);

  return {
    en: pagesEn.paths,
    de: pagesDe.paths,
    ar: pagesAe.paths,
    az: pagesAz.paths,
    'en-gb': pagesUk.paths,
    kz: pagesKz.paths,
    pl: pagesPl.paths,
  };
}
